<template>
  <div class="signin--step">
    <vue-headful title="Sign In" />

    <v-layout wrap row>
      <v-flex xs12>
        <StepTitle>Sign In</StepTitle>
      </v-flex>
    </v-layout>

    <BaseAlert v-if="displayLoggedOutAlert" :hg-value="true" hg-type="warning">
      Your session has expired. Please log in to continue.
    </BaseAlert>

    <SigninForm :apiError="error" :apiLoading="loading" @submit="submit" />
  </div>
</template>

<script>
import { Components } from '@spectorasoftware/homegauge-vue';

import AppDefaults from '@/constants/app-defaults';
import SigninForm from '@/components/forms/SigninForm.vue';
import StepTitle from '@/components/StepTitle.vue';
import RouteNameConstants from '@/router/constants/route-names';
import StepUtilities from '@/router/utilities/step-utilities';

const { BaseAlert } = Components;

export default {
  components: {
    BaseAlert,
    SigninForm,
    StepTitle,
  },
  data() {
    return {
      error: false,
      loading: false,
      forgotPasswordUrl: AppDefaults.forgotPasswordUrl,
    };
  },
  computed: {
    displayLoggedOutAlert() {
      return this.$route && this.$route.params.loggedOut;
    },
  },
  methods: {
    async submit(payload) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.error = false;

      try {
        const signedInPerson = await this.$store.dispatch('Auth/loginUser', payload);
        if (!signedInPerson || !signedInPerson.access_token) {
          this.showError = true;
          return;
        }
        await this.$store.dispatch('Auth/getPerson');
        StepUtilities.goToContactStep(this.$router);
      } catch (err) {
        this.error = true;
      }

      this.loading = false;
    },
  },
  mounted() {
    this.$store.commit('setStepIndex',
      StepUtilities.getStepIndexByRouteName(RouteNameConstants.AppointmentSignIn));
  },
};
</script>
